import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../basic/ThemeProvider';
import Typography from '../../../basic/Typography';
import { Button } from '../../../basic/Button';
import ProductCard from '../../../composite/ProductCard';
import { ModeTabs, ModeTab } from '../../../composite/ModeTabs';
import { ProductsSectionContent } from '../../../../content/types';
import SocialFooter from '../SocialFooter';
import './styles.css';

interface ProductsSectionProps {
  content: ProductsSectionContent;
  productTabs?: ModeTab[];
  companyName?: string;
  isSignedIn?: boolean;
}

const ProductsSection: React.FC<ProductsSectionProps> = ({ content, productTabs, companyName, isSignedIn = false }) => {
  const { theme } = useTheme();
  const navigate = useNavigate();

  const sectionStyle = {
    '--glow-color': theme.colors.accent.primary,
  } as React.CSSProperties;

  return (
    <section id={content.id} className="products-section" style={sectionStyle}>
      <div className="products-section-content">
        {/* Hero-style header */}
        <div className="products-header">
          <div className="products-logo">
            <img
              src="/news/demo/public/assets/logo.png"
              alt="vMonad Logo"
              className="products-logo-img"
            />
            <Typography variant="h3" className="products-logo-text">
              vMonad
            </Typography>
          </div>
          <Typography
            variant="h1"
            align="center"
            className="products-title"
          >
            {content.title}
          </Typography>
          <Typography
            variant="body1"
            align="center"
            className="products-tagline"
          >
            {content.header}
          </Typography>
          {content.subHeader && (
            <Typography
              variant="caption"
              align="center"
              className="products-support-line"
            >
              {content.subHeader}
            </Typography>
          )}
          <div className="products-cta-buttons">
            <Button
              onClick={() => navigate('/studio')}
              className="products-cta-primary"
            >
              {isSignedIn ? 'Launch Studio' : 'Login'}
            </Button>
            <Button
              onClick={() => navigate('/blog/world-unification')}
              className="products-cta-secondary"
            >
              Read the Vision
            </Button>
          </div>

          <div className="products-grid">
            {content.products.map((product, index) => (
              <ProductCard key={index} content={product} />
            ))}
          </div>
        </div>

        {/* Built on vMonad - Product Tabs */}
        {productTabs && productTabs.length > 0 && (
          <div className="products-tabs-section">
            <ModeTabs
              tabs={productTabs}
              sectionTitle="New Media powered by vMonad"
            />
          </div>
        )}

        {/* Footer - integrated into single page */}
        {companyName && (
          <div className="products-footer-section">
            <SocialFooter companyName={companyName} />
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductsSection;